<template>
  <div>
    <div class="columns is-desktop">
      <div class="column">
        <config-system-general-properties
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <config-system-rule-properties
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
      </div>
      <div class="column">
        <config-system-system-labels
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <config-system-system-message
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <config-system-smtp-properties
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <!-- <config-system-field-masking
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        /> -->
        <quick-tips-system-configuration/>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigSystemGeneralProperties from '@/components/ConfigSystemGeneralProperties.vue';
import ConfigSystemRuleProperties from '@/components/ConfigSystemRuleProperties.vue';
import ConfigSystemSmtpProperties from '@/components/ConfigSystemSmtpProperties.vue';
import ConfigSystemSystemLabels from '@/components/ConfigSystemSystemLabels.vue';
import ConfigSystemSystemMessage from '@/components/ConfigSystemSystemMessage.vue';
// import ConfigSystemFieldMasking from '@/components/ConfigSystemFieldMasking.vue';
import QuickTipsSystemConfiguration from '@/components/QuickTipsSystemConfiguration.vue';

export default {
  components: {
    ConfigSystemGeneralProperties,
    ConfigSystemRuleProperties,
    ConfigSystemSmtpProperties,
    ConfigSystemSystemLabels,
    ConfigSystemSystemMessage,
    // ConfigSystemFieldMasking,
    QuickTipsSystemConfiguration,
  },
  data() {
    return {
      editOtherPanels: false,
    };
  },
  methods: {
    allowEditOtherPanels() {
      this.editOtherPanels = !this.editOtherPanels;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
